import React from "react";
import { Link } from "react-router-dom";
import "./Sidebar.css";

const Sidebar = () => {
  return (
    <div className="my-sidebar">
      <h2 className="my-sidebar-title">Settings</h2>
      <div className="my-sidebar-links">
        <Link to="/lab-details" className="my-sidebar-link">Lab Details</Link>
        <Link to="#" onClick={(e) => e.preventDefault()} className="my-sidebar-link my-sidebar-disabled">Store</Link>
        <Link to="/users" className="my-sidebar-link">Users</Link>
        <Link to="#" onClick={(e) => e.preventDefault()} className="my-sidebar-link my-sidebar-disabled">Permission Groups</Link>
        <Link to="/accountTable" className="my-sidebar-link">Accounts</Link>
        <Link to="/financeOwerview" className="my-sidebar-link">Finances</Link>
        <Link to="/owersetting" className="my-sidebar-link">Case Settings</Link>
      </div>
    </div>
  );
};

export default Sidebar;